module.exports = __webpack_public_path__ + "img/image30.e86ba1c9.png";